import { Box, Divider, Group, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconLayoutSidebar } from '@tabler/icons-react';
import { usePreferencesStore } from '../../../stores';
import Switch from '../../../components/ui/inputs/Switch';
import SegmentedControl from '../../../components/ui/navigation/SegmentedControl';

export default function MenuPreferencesSection() {
  const menuIconOnly = usePreferencesStore((state) => state.menuIconOnly);
  const toggleMenuIconOnly = usePreferencesStore((state) => state.toggleMenuIconOnly);
  const menuAutoHide = usePreferencesStore((state) => state.menuAutoHide);
  const setMenuAutoHide = usePreferencesStore((state) => state.setMenuAutoHide);
  const menuDensity = usePreferencesStore((state) => state.menuDensity);
  const setMenuDensity = usePreferencesStore((state) => state.setMenuDensity);
  const menuShowSectionCounts = usePreferencesStore((state) => state.menuShowSectionCounts);
  const toggleMenuShowSectionCounts = usePreferencesStore(
    (state) => state.toggleMenuShowSectionCounts
  );

  return (
    <Stack gap="lg">
      {/* Header */}
      <Group gap="sm">
        <ThemeIcon size="lg" radius="md" variant="light" color="violet">
          <IconLayoutSidebar size={20} />
        </ThemeIcon>
        <Box>
          <Text fw={600}>Menu & Navigation</Text>
          <Text size="xs" c="dimmed">
            Customize sidebar and menu behavior
          </Text>
        </Box>
      </Group>

      <Divider />

      <Switch
        label="Icon-only mode"
        description="Show only icons without labels for a compact sidebar"
        checked={menuIconOnly}
        onChange={toggleMenuIconOnly}
      />

      <Switch
        label="Auto-hide sidebar"
        description="Automatically hide sidebar when not in use"
        checked={menuAutoHide}
        onChange={(e) => setMenuAutoHide(e.target.checked)}
      />

      <Switch
        label="Show badge counts"
        description="Display notification and count badges on menu items"
        checked={menuShowSectionCounts}
        onChange={toggleMenuShowSectionCounts}
      />

      <Box>
        <Text size="sm" fw={500} mb="xs">
          Menu density
        </Text>
        <Text size="xs" c="dimmed" mb="xs">
          Adjust spacing between menu items
        </Text>
        <SegmentedControl
          fullWidth
          activeGradient
          data={[
            { label: 'Compact', value: 'compact' },
            { label: 'Regular', value: 'regular' },
            { label: 'Comfortable', value: 'comfortable' },
          ]}
          value={menuDensity}
          onChange={(value) => setMenuDensity(value as typeof menuDensity)}
        />
      </Box>
    </Stack>
  );
}
